import { localStorageSync } from 'ngrx-store-localstorage'

import { ActionReducer } from '@ngrx/store'

export function localStorageSyncReducer(
  reducer: ActionReducer<any>
): ActionReducer<any> {
  return localStorageSync({
    keys: [
      'auth',
      'configurationOptions',
      'oidc',
      'settings',
      'persistent-user-role'
    ],
    rehydrate: true,
    storageKeySerializer: (key) => 'delcom_' + key
  })(reducer)
}
